module.exports = __webpack_public_path__ + "media/applicants/device_signup_5-fr-11ec9237.jpg";